module.exports = __webpack_public_path__ + "img/桔梗.d678c06d.jpg";